import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import SettingService from "../SettingService";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

type UpdateProps = {
  modal: boolean;
  hidePopup: () => void;
  showSuccess: () => void;
};

const UpdatePasswordModal = (props: UpdateProps) => {
  const { t } = useTranslation();
  const [currentPassword, setCurrentPassowrd] = useState<string>("");
  const [newPassword, setNewPassowrd] = useState<string>("");
  const [confirmNewPassowrd, setConfirmNewPassowrd] = useState<string>("");
  const [errors, setErrors] = useState<any>({});

  const settingService = new SettingService();

  const validate = () => {
    let error: any = {};

    if (currentPassword === "") {
      error["current"] = t("current_pass_error");
      setErrors(error);
    }
    if (newPassword === "") {
      error["newPass"] = t("new_pass_error");
      setErrors(error);
    }
    if (confirmNewPassowrd === "confirm_pass_error") {
      error["confirmPass"] = t("pass_no_match");
      setErrors(error);
    }
    if (
      newPassword &&
      confirmNewPassowrd &&
      confirmNewPassowrd !== newPassword
    ) {
      error["no_match"] = t("pass_no_match");
      setErrors(error);
    }

    if (Object.keys(error).length > 0) {
      return false;
    }
    return true;
  };

  const renderFooter = () => {
    return (
      <div>
        <Button
          label={t("cancel")}
          icon="pi pi-times"
          onClick={() => props.hidePopup()}
          className="p-button-text"
        />
        <Button
          className="create-plant"
          label={t("update_password")}
          icon="pi pi-check"
          onClick={() => {
            setErrors({});
            if (validate()) {
              const data = {
                username: localStorage.getItem("username"),
                password: currentPassword,
              };
              settingService.verifyPassword(data).then((response) => {
                if (response !== 200) {
                  let error: any = {};
                  error["wrong_pass"] = t("current_pass_no_find");
                  setErrors(error);
                } else {
                  const data = {
                    password: newPassword,
                    email: localStorage.getItem("email"),
                    keycloak_id: localStorage.getItem("keycloak_id"),
                  };
                  settingService.updatePassword(data).then((response) => {
                    if (response.status === 200) {
                      props.hidePopup();
                      props.showSuccess();
                    } else {
                      const error: any = {};
                      error["wrong"] = "Something went wrong!";
                      setErrors(error);
                    }
                  });
                }
              });
            }
          }}
          autoFocus
        />
      </div>
    );
  };

  return (
    <>
      <Dialog
        header={t("update_password")}
        visible={props.modal}
        style={{ width: "30vw" }}
        footer={renderFooter()}
        onHide={() => props.hidePopup()}
      >
        <div>
          <p className="error-message">{errors["wrong"]}</p>

          <div className="grid align-items-center mb-6">
            <div className="col-12 lg:col-4">
              <h5 className="mb-2">{t("current_password")}</h5>
            </div>
            <div className="col-12 lg:col-6">
              <Password
                value={currentPassword}
                onChange={(e) => setCurrentPassowrd(e.target.value)}
                feedback={false}
                toggleMask
              />
              <p className="error-message">{errors["current"]}</p>
              <p className="error-message">{errors["wrong_pass"]}</p>
            </div>
          </div>
          <div className="grid align-items-center mb-6">
            <div className="col-12 lg:col-4">
              <h5 className="mb-2">{t("new_password")}</h5>
            </div>
            <div className="col-12 lg:col-6">
              <Password
                value={newPassword}
                onChange={(e) => setNewPassowrd(e.target.value)}
                feedback={false}
                toggleMask
              />
              <p className="error-message">{errors["newPass"]}</p>
            </div>
          </div>

          <div className="grid align-items-center mb-6">
            <div className="col-12 lg:col-4">
              <h5 className="mb-2">{t("confirm_new_password")}</h5>
            </div>
            <div className="col-12 lg:col-6">
              <Password
                value={confirmNewPassowrd}
                onChange={(e) => setConfirmNewPassowrd(e.target.value)}
                feedback={false}
                toggleMask
              />
              <p className="error-message">{errors["confirmPass"]}</p>
              <p className="error-message">{errors["no_match"]}</p>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default UpdatePasswordModal;
